<tl-subscription-plans
  *ngIf="activeTab === SubscriptionPlanTabsEnums.plans"
  [planId]="selectedPlan"
  [currentPlan]="usedSubscriptionPlan"
  (clickOnPlan)="selectedPlan = $event; onChangePlanTab.emit(SubscriptionPlanTabsEnums.singlePlan)"
  (clickToSubscribeOnPlan)="selectedPlan = $event; onChangePlanTab.emit(SubscriptionPlanTabsEnums.payment)"
  (clickToCancelSubscription)="cancelPlan = $event; isCancelSubscriptionModalOpen = true">
</tl-subscription-plans>
<tl-single-plan
  *ngIf="activeTab === SubscriptionPlanTabsEnums.singlePlan"
  [plan]="selectedPlan"
  [currentPlan]="usedSubscriptionPlan"
  (clickToSubscribeOnPlan)="selectedPlan = $event; onChangePlanTab.emit(SubscriptionPlanTabsEnums.payment)"
  (clickToCancelSubscription)="cancelPlan = $event; isCancelSubscriptionModalOpen = true">
</tl-single-plan>
<tl-payment
  *ngIf="activeTab === SubscriptionPlanTabsEnums.payment"
  [plan]="selectedPlan"
  [currentPlan]="usedSubscriptionPlan"
  (planUpgraded)="onPlanUpdate.emit()"
></tl-payment>
<tl-cancel-subscription-modal
  *ngIf="isCancelSubscriptionModalOpen"
  [currentPlan]="usedSubscriptionPlan"
  (cancelModal)="isCancelSubscriptionModalOpen = false"
  (confirmModal)="onConfirmCancelSubscription()"
></tl-cancel-subscription-modal>
<span class="message-subscription" *ngIf="hasMobileSubscriptionActive && hasWebSubscriptionActive">To avoid multiple subscirption charges, please unsubscribe from your previous subscriptions on your mobile device. You can find more details how to unsubscribe on mobile device in TheLysts Mobile Application -> Settings -> Subscriptions</span>

